import { useState } from 'react'
import { formatInteger } from '../../utils/formatting'
import { CollapsibleSection } from '../UI/CollapsibleSection/CollapsibleSection'
import { CONVENIENCE_DOOR_TABLE_KEY } from 'constants/tableQueryKeys'
import { ConvenienceDoorTable } from 'components/DataExpansionComponents/GooglePlaces/ConvenienceDoors/ConvenienceDoorsTable/ConvenienceDoorsTable'

const ConvenienceDoorsTableSection = ({
  forChainProxyId,
}: {
  forChainProxyId: number
}) => {
  const [convenienceCount, setLodgingCount] = useState<number>(0)
  const TABLE_KEY = `${CONVENIENCE_DOOR_TABLE_KEY}-${forChainProxyId}`

  return (
    <>
      <CollapsibleSection
        forceClose={convenienceCount < 1}
        summary={
          <div className={'flex justify-between items-center w-full'}>
            <div>
              Doors{' '}
              <span className={'font-thin'}>
                ({formatInteger(convenienceCount)})
              </span>
            </div>
          </div>
        }
      >
        <ConvenienceDoorTable
          tableKey={TABLE_KEY}
          setTotalRowsCount={(count) => setLodgingCount(count?.count ?? 0)}
          hideCreateCompanyButton
          baseFilters={{ chain_proxy_id: forChainProxyId }}
        />
      </CollapsibleSection>
    </>
  )
}

export default ConvenienceDoorsTableSection
